import React, { useRef } from 'react';
import { ISearchModuleProps } from '../../../interfaces/interfaces';
import SearchInput from '../../elements/Inputs/SearchInput';

function SearchModule(props: ISearchModuleProps): JSX.Element {
  const { headline, textContent, searchActionUrl, searchParams } = props;
  const formRef = useRef<HTMLFormElement>(null);

  return (
    <div className="tile-padding">
      <h2 className="hl-2">{headline}</h2>
      <p className="tx_4">{textContent}</p>
      <form action={searchActionUrl} ref={formRef}>
        <SearchInput
          className="input default-input search-input"
          inputName="query"
          searchParams={searchParams}
          onSubmit={() => {
            formRef?.current?.submit();
          }}
        />
      </form>
    </div>
  );
}
export default SearchModule;
